import GlobalRequest from './global-request';
import { resetUnauthenticatedFlag } from './axios-api';
const PASSWORD_RESET_URL = 'v2/admin/users/password-reset';

class AuthService {
    async login(user, commit) {
        return await GlobalRequest.postRequest('v2/login', user)
            .then((res) => {
                // console.log('~~ login', res.data);
                let userData = res.data;
                if (res.statusCode == 200 && userData.token) {
                    resetUnauthenticatedFlag();

                    commit('loginSuccess', userData);
                    commit('setTokenRefreshTimer');
                }
                return res;
            })
            .catch((err) => {
                err = err.data || err;
                return err;
            });
    }

     async verifyOtp(user, commit) {
        return await GlobalRequest.postRequest('v2/verify-otp', user)
            .then((res) => {
                let userData = res.data;
                if (res.statusCode == 200 && userData.token) {
                    commit('loginSuccess', userData);
                    commit('setTokenRefreshTimer');
                }
                return res;
            })
            .catch((err) => {
                return err;
            });
    }

    async refreshToken(commit) {
        return await GlobalRequest.getRequest('v2/refresh')
            .then((res) => {
                if (res.statusCode == 200) {
                    commit('setRefreshToken', res.data);
                    return res.data;
                } else {
                    commit('setRefreshTokenFailure');
                    return Promise.reject();
                }
            })
            .catch((err) => {
                err = err.response.data || err;
                return err;
            });
    }

    async resetPassword(user, commit) {
        return await GlobalRequest.postRequest(PASSWORD_RESET_URL, user)
            .then((res) => {
                let userData = res.data;
                if (res.statusCode == 200 && userData.token) {
                    commit('loginSuccess', userData);
                    commit('setTokenRefreshTimer');
                }
                return res;
            })
            .catch((err) => {
                err = err.response.data || err;
                return err;
            });
    }

    async resetPasswordRequest() {
        return await GlobalRequest.getRequest(PASSWORD_RESET_URL)
            .then((res) => {
                return res;
            })
            .catch((err) => {
                err = err.response.data || err;
                return err;
            });
    }
}

export default new AuthService();
